import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { NumberUtilities } from '../../utilities/number-utilities';
import { TimeUtilities } from '../../utilities/time-utilities';
import { TimeModelOptions } from '../options/time-model-options';
import { DateModel } from '../primitive/date.model';
import { NumberModel } from '../primitive/number.model';
import { TextModel } from '../primitive/text.model';
import { TimeModel } from '../primitive/time.model';
import { CompositeModel } from './composite.model';

export class HistoryModel extends CompositeModel {
    public shortText: TextModel;
    public notificationType: TextModel;
    public createdDate: DateModel;
    public createdOn: TimeModel;
    public cseName: TextModel;
    public outstanding: NumberModel;
    public notificationNo: TextModel;
    public taskNumber: TextModel;
    public pos: NumberModel;
    public readonly id: number;
    public constructor(
        shortText: string,
        notificationType: ConfigConstants.NotificationTypes,
        creationDate: moment.Moment,
        cseName: string,
        outstanding: number,
        notificationNo: string,
        taskNumber: string,
        pos: number,
    ) {
        super('HistoryModel');

        this.id = moment().valueOf() + NumberUtilities.getRandomNumberBetweenMinAndMax();
        this.shortText = <TextModel>this.set(new TextModel('ShortText', shortText));
        this.notificationType = <TextModel>this.set(new TextModel('NotificationType', notificationType));
        this.createdDate = <DateModel>this.set(new DateModel('Erdat', creationDate));
        this.createdOn = <TimeModel>(
            this.set(
                new TimeModel(
                    'Erdat',
                    creationDate,
                    new TimeModelOptions({ format: ConfigConstants.formatXSDTimeDuration }),
                ),
            )
        );
        this.cseName = <TextModel>this.set(new TextModel('CseName', cseName));
        this.outstanding = <NumberModel>this.set(new NumberModel('Outstanding', outstanding));
        this.notificationNo = <TextModel>this.set(new TextModel('NotificationNo', notificationNo));
        this.taskNumber = <TextModel>this.set(new TextModel('TaskNumber', taskNumber));
        this.pos = <NumberModel>this.set(new NumberModel('Pos', pos));
    }

    public static fromOData(data: ODataHistoryModel): HistoryModel {
        return new HistoryModel(
            data.ShortText,
            data.NotificationType,
            TimeUtilities.momentFromDateAndTime(data.CreatedDate, data.CreatedOn),
            data.CSEName,
            parseInt(data.Outstanding, 10),
            data.NotificationNo,
            data.TaskNumber,
            parseInt(data.Counter, 10),
        );
    }
}

export interface ODataHistoryModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_58_SRV.History';
    };
    ShortText: string;
    NotificationType: ConfigConstants.NotificationTypes;
    CreatedDate: string;
    CreatedOn: string;
    CSEName: string;
    Outstanding: string;
    NotificationNo: string;
    TaskNumber: string;
    Counter: string;
}
